export class DetailEvents {
    static get select(): string { return "productionplanning_detail_select"; }
    static get afterArbetsorderSave(): string { return "productionplanning_detail_afterArbetsorderSave"; }
    static get afterArbetsorderIsRemoved(): string { return "productionplanning_detail_afterArbetsorderIsRemoved"; }
}
